import { AdminTabGroup } from 'types/admin-tabs';

export const ADMIN_TAB_GROUPS: AdminTabGroup[] = [
  {
    label: 'System',
    tabs: [
      { name: 'Structure Types', index: 0 },
      { name: 'Attributes', index: 2 },
      { name: 'Attribute FollowUps', index: 3 },
      { name: 'Sizing Calculator Multipliers', index: 19 }
    ]
  },
  {
    label: 'Structure',
    tabs: [
      { name: 'Spaces', index: 1 },
      { name: 'Insulation Levels', index: 11 },
      { name: 'Glass/Doors (legacy)', index: 4 }
    ]
  },
  {
    label: 'System Design',
    tabs: [
      { name: 'Air Handlers', index: 5 },
      { name: 'System Filtering', index: 7 },
      { name: 'Ducted System Filtering', index: 24 },
      { name: 'Design Rules', index: 10 }
    ]
  },
  {
    label: 'AI',
    tabs: [
      { name: 'Chatbot Categories', index: 15 },
      { name: 'Chatbot Sub-Agents', index: 16 },
      { name: 'Sub-Agent Tools', index: 17 },
      { name: 'AI Models', index: 13 },
      { name: 'AI Task Models', index: 14 },
      { name: 'Sub-Type Rules', index: 18 },
      { name: 'AI Prompts (legacy)', index: 9 }
    ]
  },
  {
    label: 'Content',
    tabs: [
      { name: 'Text Keys', index: 12 },
      { name: 'Filter Tooltips', index: 25 },
      { name: 'Existing Equipment Tooltips', index: 26 },
      { name: 'Coverage Tooltips', index: 27 }
    ]
  },
  {
    label: 'Scoring',
    tabs: [
      { name: 'Scenarios', index: 20 },
      { name: 'Score Definitions', index: 21 },
      { name: 'Customer Preferences', index: 22 }
    ]
  },
  {
    label: 'Customers',
    tabs: [{ name: 'System Selector Customers', index: 23 }]
  },
  {
    label: 'Diagnostics',
    tabs: [{ name: 'Error Logs', index: 28 }]
  }
];
